// removed by extract-text-webpack-plugin
module.exports = {"base":"_3USPqBL6HpdVXsOAmkyRbx","clickable":"_1kz8MGZV2FqGcjIPvYzFrY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisIcon.scss
// module id = 1047
// module chunks = 0